enum PlanCode {
  Annual = 'annual',
  AnnualOnce = 'annualOnce',
  SevenDayTrial = 'sevenDayTrial',
  ThreeYear = 'threeYr',
  Monthly = 'monthly'
}

export default PlanCode;
